<template>
  <div>
    <!-- <div class="update-phone-text">
      <div :class="isStep ?'yes-step':'phone-old'">1.验证原号码</div>
      <div :class="!isStep ?'yes-step':'phone-new'" class="phone-new">2.绑定新手机</div>
    </div> -->
    <div v-if="isStep">
      <div class="colRight">
        <van-field readonly v-model="dataOld.phone" center clearable placeholder="请输入新手机号码">
          <template #button>
            <van-button size="small" color="#D6BE93" @click="getCodeEvOld" v-if="getCodeOld" type="primary">获取验证码</van-button>
            <div class="has-get-code" v-else>{{countOld}}秒后重发</div>
          </template>
        </van-field>
      </div>
      <div class="colRight no-top-border">
        <van-field v-model="dataOld.msgCode" placeholder="请输入验证码" />
      </div>
      <van-button color="#D6BE93" class="btSubmitStyle" @click="nextStep" type="primary">下一步</van-button>
    </div>
    <div v-else>
      <div class="colRight">
        <van-field v-model="dataNew.newMobile" center clearable placeholder="请输入新手机号码">
          <template #button>
            <van-button size="small" color="#D6BE93" @click="getCodeEvNew" v-if="getCodeNew" type="primary">获取验证码</van-button>
            <div class="has-get-code" v-else>{{countNew}}秒后重发</div>
          </template>
        </van-field>
      </div>
      <div class="colRight no-top-border">
        <van-field v-model="dataNew.newMobileCode" placeholder="请输入验证码" />
      </div>
      <van-button color="#D6BE93" class="btSubmitStyle" @click="registerUser" type="primary">下一步</van-button>
    </div>
    <div class="tip-box">
      <div class="title-tip">
        <van-icon name="info" class="icon-tip" color="#999" />温馨提示：</div>
      <div class="text-tip">手机号码修改成功后需要使用新的手机号码进行登录。</div>

    </div>
  </div>
</template>





<script>
import {
  authRegCaptcha,
  authResetMobile,
  authVerifyOldPhone
} from "@/api/index";
import { Dialog, Toast } from "vant";

export default {
  data() {
    return {
      userPhone: this.$store.state.base.userInfo.userInfo.nickName,
      SMCode: "",
      newPhoneNumber: "",
      getCodeOld: true,
      isRepwd: "password",
      timerOld: null,
      countOld: "",
      getCodeNew: true,
      timerNew: null,
      countNew: "",
      isStep: true,
      dataOld: {
        phone: this.$store.state.base.userInfo.userInfo.nickName, //旧手机号
        msgCode: "", //验证码
        uuid: "" //请求验证返回
      },
      dataNew: {
        newMobile: "", //新手机号
        newMobileCode: "", //验证码
        oldPhoneSecretKey: "", //验证老手机号秘钥
        uuid: "" //请求验证返回
      }
    };
  },
  mounted() {
    console.log(this.$store.state.base.userInfo.userInfo.nickName);
    // this.userPhone = this.$store.state.base.userInfo.nickName;
    console.log(this.userInfo);
  },
  methods: {
    nextStep() {
      console.log(this.dataOld);
      if (this.dataOld.msgCode == "") {
        Dialog.alert({
          title: "提示",
          message: "验证码为空"
        });
        return;
      }
      //提交修改
      // Dialog.confirm({
      //   title: "提示",
      //   message: "确定更换手机号码吗？"
      // })
      //   .then(() => {
      console.log(this.dataOld);
      // on confirm
      authVerifyOldPhone(this.dataOld).then(res => {
        console.log(res);
        if (res.data.errno == 0) {
          // Toast("更新成功");
          this.isStep = false;
          this.dataNew.oldPhoneSecretKey = res.data.data;

          // this.$router.replace("/login");
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg
          });
        }
      });
      // })
      // .catch(() => {
      //   // on cancel
      // });
    },
    registerUser() {
      console.log(this.dataNew);
      if (this.dataNew.newMobile == "") {
        Dialog.alert({
          title: "提示",
          message: "新手机号为空"
        });
        return;
      }
      if (this.dataNew.newMobile.length != 11) {
        Dialog.alert({
          title: "提示",
          message: "请正确填写新手机号"
        });
        return;
      }
      if (this.dataNew.newMobileCode == "") {
        Dialog.alert({
          title: "提示",
          message: "验证码为空"
        });
        return;
      }
      //提交修改
      Dialog.confirm({
        title: "提示",
        message: "确定更换手机号码吗？"
      })
        .then(() => {
          // on confirm
          authResetMobile(this.dataNew).then(res => {
            console.log(res);
            if (res.data.errno == 0) {
              Toast("更新成功");
              this.$router.replace("/login");
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.errmsg
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    getCodeEvOld() {
      //发送短信验证码
      let mobile = {
        mobile: this.userPhone
      };
      authRegCaptcha(mobile).then(res => {
        console.log(res);
        if (res.data.return_code == 0) {
          this.dataOld.uuid = res.data.data.uuid;
          this.getCodeOld = false;
          const TIME_COUNT = 60;
          if (!this.timerOld) {
            this.countOld = TIME_COUNT;
            this.timerOld = setInterval(() => {
              if (this.countOld > 0 && this.countOld <= TIME_COUNT) {
                this.countOld--;
              } else {
                this.getCodeOld = true;
                clearInterval(this.timerOld);
                this.timerOld = null;
              }
            }, 1000);
          }
        } else {
          Dialog.alert({
            message: res.data.return_message
          }).then(() => {
            // on close
          });
        }
      });
    },
    getCodeEvNew() {
      if (this.dataNew.newMobile == "") {
        Dialog.alert({
          title: "提示",
          message: "新手机号为空"
        });
        return;
      }
      if (this.dataNew.newMobile.length != 11) {
        Dialog.alert({
          title: "提示",
          message: "请正确填写新手机号"
        });
        return;
      }
      //发送短信验证码
      let mobile = {
        mobile: this.dataNew.newMobile
      };
      authRegCaptcha(mobile).then(res => {
        console.log(res);
        if (res.data.return_code == 0) {
          this.dataNew.uuid = res.data.data.uuid;
          this.getCodeNew = false;
          const TIME_COUNT = 60;
          if (!this.timerNew) {
            this.countNew = TIME_COUNT;
            this.timerNew = setInterval(() => {
              if (this.countNew > 0 && this.countNew <= TIME_COUNT) {
                this.countNew--;
              } else {
                this.getCodeNew = true;
                clearInterval(this.timerNew);
                this.timerNew = null;
              }
            }, 1000);
          }
        } else {
          Dialog.alert({
            message: res.data.return_message
          }).then(() => {
            // on close
          });
        }
      });
    }
  }
};
</script>


<style scoped lang="scss">
.update-phone-text {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 4rem;
  .phone-old {
    font-size: 1.6rem;
  }
  .phone-new {
    font-size: 1.6rem;
  }
  .yes-step {
    font-size: 1.6rem;
    color: red;
  }
}
.tip-box {
  width: 90%;
  margin: 2rem auto;
}
.icon-tip {
  font-size: 2rem;
}
.title-tip {
  font-size: 1.6rem;
  text-align: left;
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
}
.text-tip {
  font-size: 1.4rem;
  text-align: left;
}
// .update-phone {
//   height: 100%;
//   box-sizing: border-box;
//   padding-top: 2rem;
// }
// .colLeft {
//   background-color: white;
//   height: 40px;
//   display: flex;
//   align-items: center;

//   justify-content: center;
//   text-align: justify;
// }
.colRight {
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.no-top-border {
  border-top: none;
}
// .colBottom {
//   height: 40px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   text-align: justify;
// }

// .login-top {
//   display: flex;
//   justify-content: space-between;
//   margin: 2.2rem auto 4rem;
//   width: 90%;
//   .login-text {
//     font-size: 1.75rem;
//     font-weight: bold;
//     display: flex;
//     text-align: left;
//     flex-direction: column;
//     .line {
//       background: #222b45;
//       border-radius: 2.5px;
//       width: 3.1rem;
//       height: 0.5rem;
//       margin-top: 1.2rem;
//     }
//     span {
//       font-family: PingFangSC-Medium;
//       font-size: 2.8rem;
//       color: #222b45;
//       line-height: 4rem;
//     }
//   }
//   .login-icon {
//     width: 6.8rem;
//     height: 6.8rem;
//     background: url("../../assets/index/logo_img.png") center center no-repeat;
//     background-color: #d6be93;
//     border-radius: 50%;
//     opacity: 0.5;
//     box-sizing: border-box;
//   }
// }
// .filedContainer {
//   padding: 0 10%;
//   height: auto;
//   background-color: white;
// }
.btSubmitStyle {
  width: 80%;
  border-radius: 5px;
  margin: 40px auto 0;
}

// .checkboxStyle {
//   bottom: 20px;
//   position: absolute;
//   text-align: center;
//   margin-top: 6rem;
//   width: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   text-align: justify;
//   span {
//     font-family: PingFangSC-Medium;
//     font-size: 1.4rem;
//     color: #d6be93;
//     text-align: center;
//     line-height: 1.4rem;
//     text-decoration: underline;
//   }
// }
// .has-get-code {
//   opacity: 0.2;
//   background: rgba(44, 44, 57, 0.2);
//   border: 0 solid rgba(20, 20, 20, 0.4);
//   border-radius: 4px;
//   font-family: PingFangSC-Regular;
//   font-size: 1.2rem;
//   color: #141414;
//   letter-spacing: 0;

//   height: 3rem;
//   line-height: 2.9rem;

//   text-align: center;
//   width: 7.2rem;
// }
// /deep/ .van-row {
//   border-bottom: 1px solid #c2c2c2;
//   width: 100%;
//   overflow: hidden;
//   height: 6.8rem;
//   display: flex;
//   align-items: flex-end;
//   box-sizing: border-box;
//   padding-bottom: 0.4rem;
// }
// /deep/ .icon-shouji1,
// .icon-yanzhengma2,
// .icon-mima {
//   font-weight: 600;
//   font-size: 2.2rem;
// }
// .go-back {
//   display: inline-block;
//   width: 100%;
//   text-align: left;
//   font-size: 2.4rem;
//   margin: 2rem;
// }
// /deep/ .van-checkbox__label {
//   font-size: 1.4rem;
// }
</style>



// WEBPACK FOOTER //
// src/view/person/updatePhone.vue